<div
  class="motif-row"
  [attr.aria-disabled]="isDisabled"
  [class.disabled-cell]="isDisabled"
  [style.cursor]="isDisabled ? 'not-allowed' : 'pointer'"
>
  <div class="motif-col-xs-7 motif-col-sm-7 motif-col-md-7 motif-col-lg-9">
    {{ value }}
  </div>
  <div class="motif-col-xs-5 motif-col-sm-5 motif-col-md-5 motif-col-lg-3">
    <motif-icon
      class="edit-icon"
      [iconFunction]="iconEdit"
      (click)="enableEdit()"
      [style.pointer-events]="isDisabled ? 'none' : 'auto'"
      [style.opacity]="isDisabled ? 0.5 : 1"
    ></motif-icon>
  </div>
</div>
